import Firebase from "../images/firebase.svg";
import MUI from "../images/mui.png";
import OpenAI from "../images/openai.png";
import PyQT5 from "../images/pyqt5.png";
import Python from "../images/python.png";
import ReactLogo from "../images/react.png";
import Next from "../images/next.svg";
import SQL from "../images/sql.png";
import Tailwind from "../images/tailwind.png";
import Typescript from "../images/typescript.png";
import Rocketteam from "../images/rocketteam.webp";
import Hacktogether from "../images/hacktogether.webp";
import Taskwise from "../images/taskwise.webp";
import PasstheLightr from "../images/passthelightr.webp";
import Hashiban from "../images/hashiban.webp";
import Iconic from "../images/iconic.webp";
import CoolSnippets from "../images/coolsnipets.webp";
import Lifetrack from "../images/lifetrack.webp";
import SSC from "../images/ssc.webp";
import AutoInvestor from "../images/autoinvestor.webp";
import Github from "../images/github.png";
import Website from "../images/website.png";
import Slides from "../images/slides.svg";
import Mongo from "../images/mongo.svg";
import Express from "../images/express.png";
import Docker from "../images/docker.png";
import Nodecook from "../images/nodecook.webp";
import GierigGroeien from "../images/gieriggroeien.webp";
import Wordpress from "../images/wordpress.png";
import GierigDashboard from "../images/gierigdashboard.webp";
import Vivilife from "../images/vivilife.webp";
import StudyBuddy from "../images/studybuddy.webp";
import Soilbeat from "../images/soilbeat.webp";
import Gradino from "../images/gradino.webp";
import Convileo from "../images/convileo.webp";

const projects = [
  {
    name: "Soilbeat",
    description: "A platform to help agronomists store, standarise, and visualize their data, with the aim of improving their soil health.",
    image: Soilbeat,
    stack: [
      { name: "React", image: ReactLogo },
      { name: "Tailwind", image: Tailwind },
    ],
    links: [],
  },
  {
    name: "Gierig Groeien",
    description: "A server that scrapes all protein powders of the Netherlands from the web, compares them, and pushes them to our wordpress site.",
    image: GierigGroeien,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "Express",
        image: Express,
      },
      {
        name: "Docker",
        image: Docker,
      },
      {
        name: "Wordpress",
        image: Wordpress,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/eiwittens_v2",
        image: Github,
      },
      {
        name: "Website",
        url: "https://gieriggroeien.nl/",
        image: Website,
      },
    ],
  },
  {
    name: "Node Cook",
    image: Nodecook,
    description: "Build instant Database & API in Mongo or Firebase, with Authentication, Authorization, CRUD, and more, and push it to your github repository",
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "Express",
        image: Express,
      },
      {
        name: "MongoDB",
        image: Mongo,
      },
      {
        name: "Docker",
        image: Docker,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/nodecook_express_frontend",
        image: Github,
      },
      {
        name: "Github backend",
        url: "https://github.com/gonzaloalonso123/nodecook_express_backend",
        image: Github,
      },
    ],
  },
  {
    name: "Subasta de Hashiban",
    description: "Main selling point for the card game 'La Subasta de Hashiban', brought by my company Tiranik Games. An inmersive website that teleports you to the kingdom of Hashiban",
    image: Hashiban,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "Typescript",
        image: Typescript,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/hashiban",
        image: Github,
      },
      {
        name: "Website",
        url: "https://hashiban.nl/",
        image: Website,
      },
    ],
  },
  {
    name: "Gradino",
    description: "Website and backoffice for restaurant in Sweden, including booking system and dashboard with analytics. (work in progress)",
    image: Gradino,
    stack: [
      {
        name: "NextJS",
        image: Next,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "Tailwind",
        image: Tailwind,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/gradino",
        image: Github,
      },
      //   {
      //     name: "Website",
      //     url: "https://ilgradino.se/",
      //     image: Website,
      //   },
    ],
  },
  {
    name: "Auto investor",
    description: "AI market prediction tool. This app retrieves market data daily and creates projections with the intention of predicting stock prices after quarterly results are released",
    image: AutoInvestor,
    stack: [
      {
        name: "Python",
        image: Python,
      },
      {
        name: "SQL",
        image: SQL,
      },
      {
        name: "PyQT5",
        image: PyQT5,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/auto_investor",
        image: Github,
      },
      {
        name: "Presentation",
        url: "https://docs.google.com/presentation/d/e/2PACX-1vT1hIJV9bzMc2y9xfWyXKb8avJUbA8JVrasahGXJLkzjtitWfD8P0zh65oEI1vsIEiUCkxHrqXN6ao3/pub?start=false&loop=false&delayms=3000",
        image: Slides,
      },
    ],
  },
  {
    name: "Scraper maker",
    description: "Create a list of pages and the elements and build an array of actions for every element interpretable by my Selenium scraping engine. Complementary to Gierig Groeien",
    image: GierigDashboard,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/eiwittens_v2/tree/main/frontend",
        image: Github,
      },
      {
        name: "Website",
        url: "https://eiwittens.web.app",
        image: Website,
      },
    ],
  },
  {
    name: "Study Buddy",
    description: "A platform where teachers can upload content, and generate quizzes with AI. Students can study the contents provided by the teacher. (work in progress)",
    image: StudyBuddy,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "OpenAI",
        image: OpenAI,
      },
      {
        name: "Tailwind",
        image: Tailwind,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/study_buddy",
      },
    ],
  },
  {
    name: "Taskwise",
    description: "Task management app with AI. This tool allows you to invite people to join your projects, manage tasks kanvan style, and use AI to help you complete the tasks or subdivide them.",
    image: Taskwise,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "OpenAI",
        image: OpenAI,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/CodeOnBoat/Project-Manager-App-Frontend",
        image: Github,
      },
      {
        name: "Website",
        url: "https://taskwise.pro/",
        image: Website,
      },
    ],
  },
  {
    name: "Iconic",
    description: "Website for a client in Sweden, a beauty saloon",
    image: Iconic,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/CodeOnBoat/iconic-browse-and-beuty",
        image: Github,
      },
      {
        name: "Website",
        url: "https://iconicbrowsandbeauty.se/",
        image: Website,
      },
    ],
  },
  {
    name: "Pass the lighter",
    description: "Lighter social platform. Every lighter has a code and can be tracked though the map as it travels the world, allowing its owners to message each other",
    image: PasstheLightr,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/pass-the-lightr",
        image: Github,
      },
      {
        name: "Website",
        url: "https://www.passthelightr.com/",
        image: Website,
      },
    ],
  },
  {
    name: "SSC",
    description: "Website for a client. Surf NFT game.",
    image: SSC,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/std-surfers-club-web",
        image: Github,
      },
      {
        name: "Website",
        url: "https://stonedsurfer.io/",
        image: Website,
      },
    ],
  },
  {
    name: "Vivilife",
    description: "Website for a Health and wellness startup in Sweden. Featuring a blog, a waiting list, and two different views for coaches and users.",
    image: Vivilife,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "Tailwind",
        image: Tailwind,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/vivilife_web",
        image: Github,
      },
      {
        name: "Website",
        url: "https://vivilife.me/",
        image: Website,
      },
    ],
  },
  {
    name: "Rocket team",
    description: "Website for a starting consultancy company, featuring contact form and multi language support.",
    image: Rocketteam,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "Tailwind",
        image: Tailwind,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/CodeOnBoat/rocketteam",
        image: Github,
      },
    ],
  },
  {
    name: "Convomeets",
    description: "Social platform for Amsterdam based meet ups",
    image: Convileo,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "MUI",
        image: MUI,
      },
    ],
    links: [],
  },
  {
    name: "Cool snippets",
    description: "Store and share your snippets easily, and generate new snippers with a prompt driven AI.",
    image: CoolSnippets,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "MUI",
        image: MUI,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/Components-Snippets",
        image: Github,
      },
      {
        name: "Website",
        url: "https://gonzalo-236c9.web.app/",
        image: Website,
      },
    ],
  },
  {
    name: "Lifetrack",
    description: "Personal diary with stats. It allows you to write your daily life, and choose which numbers you want to track daily, which you can later see represented. It stores everything in a local txt file.",
    image: Lifetrack,
    stack: [
      {
        name: "React",
        image: ReactLogo,
      },
      {
        name: "Firebase",
        image: Firebase,
      },
      {
        name: "MUI",
        image: MUI,
      },
    ],
    links: [
      {
        name: "Github",
        url: "https://github.com/gonzaloalonso123/LifeTrack",
        image: Github,
      },
    ],
  },
];

export default projects;
